import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableFAQWLP from './tableFAQWLP';

export default {
  title: 'FAQ Links WLP',
  attributeName: 'faqTable',
  helpText: '',
  getURL: 'mainHubId/mainHubConfigId/wlpFaqLinks',
  // updateURL: 'appId/areaId/wlpFaqLinks',
  // removeURL: 'appId/areaId/wlpFaqLinks',
  sessionParams: ['mainHubId','mainHubConfigId'],
  fields: [
    {
      attributeName: 'faqTable',
      type: FormInputTypes.TABLECOMPONENT,
      mode: 'NORMAL',
      helpText: '',
      configFile: tableFAQWLP,
    },
  ],
};